import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';

// Components
import HomeBannerContent from './HomeBannerContent';
import SliderAnimation from '../SliderAnimation';
import Layout4 from '../Layout4/Layout4';
import { getBannerQuery } from '../../../lib/graphql';
import { photosShow } from '../../../helpers/photosShow';
import { withQuery } from '../../../hoc/withGraphql';
import { homebanneruploadDir } from '../../../config';
import getDynamicHomeValue, { dynamicVehicleBlockValue } from '../../../helpers/GetDynamicItemName/dynamicHomeValue';

const HomeBanner = ({ layoutType, wholeData, getBannerData, intl }) => {
  let infoCollection = {};
  let title, content, bannerImage;
  const path = photosShow(homebanneruploadDir);
  const { locale } = intl;
  if (wholeData) {
    const { title: dynamicTitle, content: dynamicContent } = getDynamicHomeValue(wholeData, locale);
    title = dynamicTitle;
    content = dynamicContent;
    wholeData?.getFindYouCar?.forEach(item => {
      infoCollection[item.name] = dynamicVehicleBlockValue(item, locale);
    });
    bannerImage = path + wholeData.getBanner.image;
  }

  return (
    <>
      {layoutType && (layoutType == 1 || layoutType == 3) && <SliderAnimation layoutType={layoutType} data={getBannerData} />}
      {layoutType && layoutType == 4 && <Layout4 title={title} content={content} bannerImage={bannerImage} />}
      <HomeBannerContent layoutType={layoutType} wholeData={wholeData} infoCollection={infoCollection} getBannerData={getBannerData} />
    </>
  );
};

HomeBanner.propTypes = {
  getImageBannerData: PropTypes.shape({
    loading: PropTypes.bool,
    getImageBanner: PropTypes.object
  }),
  layoutType: PropTypes.number,
  wholeData: PropTypes.object,
  getBannerData: PropTypes.object,
  intl: PropTypes.object,
};

HomeBanner.defaultProps = {
  getImageBannerData: {
    loading: true
  },
};

export default compose(
  injectIntl,
  withQuery(getBannerQuery, {
    name: 'getBannerData',
    options: {
      ssr: false
    }
  }),
)(HomeBanner);
